import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherIconsComponent } from './feather-icons/feather-icons.component';
import { FormsModule } from '@angular/forms';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { WarehouseDeliveryProcessFailedComponent } from './dialogs/warehouse-delivery-process-dialog/warehouse-delivery-process-failed/warehouse-delivery-process-failed.component';
import { WarehouseDeliveryProcessSuccessComponent } from './dialogs/warehouse-delivery-process-dialog/warehouse-delivery-process-success/warehouse-delivery-process-success.component';
import { ImageUrlPipe } from '../pipes/image-url.pipe';



@NgModule({
  declarations: [FeatherIconsComponent, ConfirmationDialogComponent, WarehouseDeliveryProcessFailedComponent, WarehouseDeliveryProcessSuccessComponent, ImageUrlPipe],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule

  ],
  exports: [
    FeatherIconsComponent,
    ImageUrlPipe
  ]
})
export class SharedModule { }
